import {
  white,
  blue700,
  lightBlue900,
  grey900,
  greyA100,
  brownishGrey,
  green800,
  red500,
} from './colors';

const confirmation = {
  bookingConfirmationBanner: {
    background: blue700,
    text: white,
    topGradientColor: blue700,
    bottomGradientColor: lightBlue900,
  },
  sectionTitle: {
    background: '#eaf2f9',
    border: '#d8d8d8',
    title: grey900,
  },
  idWarnBackground: 'rgba(255, 210, 0, 0.15)',
  customerInfo: {
    text: grey900,
    placeholderBackground: greyA100,
  },
  shareItinerary: {
    multipleEmailText: brownishGrey,
    valid: green800,
    invalid: red500,
  },
};

export default confirmation;
